var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"invalid-feedback":"* required"}},[_c('b-form-select',{attrs:{"options":_vm.options},model:{value:(_vm.config[_vm.configKey]),callback:function ($$v) {_vm.$set(_vm.config, _vm.configKey, $$v)},expression:"config[configKey]"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }